import { loadPublicEnv } from '@sshop/config';

/**
 * Validated public env. Throws at startup if anything is missing/invalid.
 * Vite exposes only VITE_-prefixed vars; we strip the prefix before validation.
 */
const raw = Object.fromEntries(
  Object.entries(import.meta.env)
    .filter(([k]) => k.startsWith('VITE_'))
    .map(([k, v]) => [k.replace(/^VITE_/, ''), v]),
);

export const env = loadPublicEnv({ ...raw, MODE: import.meta.env.MODE });
